export const SET_LOAN = 'SET_LOAN'
